import React from 'react';

const ContentWrapper = ({children}) => {
  return (
      <div className="section template-auth">
        <div className="container">
          {children}
        </div>
      </div>
  );
};

export default ContentWrapper;